module.exports = __webpack_public_path__ + "img/MV.344d7cab.svg";